import Model from '@/lib/data/Model';

class FormDataLocation extends Model {
    static idProperty = 'id';

    fields = ['id', 'user_id', 'form_data_id', 'latitude', 'longitude', 'source', 'created_at'];

    constructor(data) {
        super(data);
        this.init();
    }
}

export default FormDataLocation;
